function ready(fn) {
	if (document.readyState != 'loading') {
		fn();
	} else if (document.addEventListener) {
		document.addEventListener('DOMContentLoaded', fn);
	} else {
		document.attachEvent('onreadystatechange', function () {
			if (document.readyState != 'loading')
				fn();
		});
	}
};

// test
window.ready(function () {

	// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
	// Polyfill for closest
	if (window.Element && !Element.prototype.closest) {
		Element.prototype.closest =
			function (s) {
				let matches = (this.document || this.ownerDocument).querySelectorAll(s),
					i,
					el = this;
				do {
					i = matches.length;
					while (--i >= 0 && matches.item(i) !== el) { };
				} while ((i < 0) && (el = el.parentElement));
				return el;
			};
	}


	const $inputs = document.querySelectorAll('.input');
	if ($inputs.length > 0) {
		$inputs.forEach($input => {
			$input.addEventListener('focus', e => {
				e.target.closest('p').classList.add('focus');
			});
			$input.addEventListener('blur', e => {
				if (e.target.value === "") {
					e.target.closest('p').classList.remove('focus');
				}
			});
		});
	}

	const $inputs_join = document.querySelectorAll('.form-element, textarea');
	if ($inputs_join.length > 0) {
		$inputs_join.forEach($input => {
			$input.addEventListener('focus', e => {
				$(e.target).closest('.acf-field').addClass('focus');
			});
			$input.addEventListener('blur', e => {
				if (e.target.value === "") {
					$(e.target).closest('.acf-field').removeClass('focus');
				}
			});
		});
	}


	if (document.getElementById('rememberme') != null && document.getElementById('rememberme').length > 0) {
		document.getElementById('rememberme').addEventListener('click', function (ev) {
			ev.target.parentNode.classList[ev.target.checked ? 'add' : 'remove']('selected');
		}, false);
	}

	var $table_attr =[];
	$('.table th').each(function() {
		$table_attr.push($(this).attr('data-content'));
	});

	$('.table tr').each(function() {
		$(this).children('td').each(function(i){
			$(this).attr('data-content', $table_attr[i]);
		});

	});


	var $radio_lists = $('.acf-radio-list');
	if ($radio_lists) {
		var $other_option = $radio_lists.find('input[value="other"]');
		var textNode = document.createTextNode('Other');
		$other_option.parent().append(textNode);
	}
});

